import * as React from 'react';
import { connect } from 'react-redux';
import * as RX from 'reactxp';
import { Window } from '../../reducers/window';
import { predictiveText } from '../../utils/api';
import { applyBreakpoints, md } from '../../utils/breakpoints';
import t from '../../utils/i18n';
import { mapStateToProps } from '../../utils/mapper';
import { body, colors, subHeader, } from '../../utils/styles';

import Check from '../../modules/svgs/check';
import ErrorX from '../../modules/svgs/error_x';

import axios from 'axios';

interface MultiTextInputProps {
    values?: string[];
    label: string;
    onChange: ({ value }: { value: any }) => void;
    window: Window & { multiplier: number };
    predictiveValues?: { value: string }[]; //tslint:disable-line
    dispatch: ({ type }: { type: string;[key: string]: any }) => void; //tslint:disable-line
    scroll: { scroller: any };
    moreSpace?: boolean;
    showError?: boolean;
}

const styles = {
    label: RX.Styles.createTextStyle({
        color: colors.grey,
    }),
    mediumWidth: RX.Styles.createViewStyle({
        width: 400,
    }),
    option: RX.Styles.createViewStyle({
        backgroundColor: colors.secondary,
        borderRadius: 5,
        flexDirection: 'row',
    }),
    optionWrapper: RX.Styles.createViewStyle({
        flexDirection: 'row',
        flexWrap: 'wrap',
    }),
    predictive: RX.Styles.createViewStyle({
        borderColor: colors.black,
    }),
    predictiveOption: RX.Styles.createViewStyle({
        cursor: 'pointer',
    }),
    submitButton: RX.Styles.createButtonStyle({
        backgroundColor: colors.primary,
    }),
    textInput: RX.Styles.createTextInputStyle({
        borderColor: 'grey',
        padding: 18,
    }),
    textRedInput: RX.Styles.createTextInputStyle({
        borderColor: 'rgb(160, 6, 45)',
        padding: 38,
    }),
    x: RX.Styles.createTextStyle({
        color: colors.white,
        fontWeight: 'bold',
    }),
};

interface StateType {
    currentValue: string;
    values: any[];
    predictive: { value: string }[]; //tslint:disable-line
    mouseOver?: string;
    textInput?: any;
    buttonFocus: boolean;
    predictiveError?: boolean;
};

const findIndex = (val, values) => {
    let index = -1;
    values.map((value, idx) => {
        if (value.value === val) {
            index = idx;
        }
    })
    return index;
}

export class MultiTextInput extends RX.Component<MultiTextInputProps, RX.CommonProps & StateType> {
    public static getDerivedStateFromProps(nextProps: any, prevState: any) {
        if (nextProps.values !== prevState.values) {
            return { values: nextProps.values };
        } else if (nextProps.predictiveValues !== prevState.predictiveValues) {
            return { predictive: nextProps.predictiveValues };
        } else {
            return null;
        }
    }

    constructor(props: MultiTextInputProps) {
        super(props);
        this.state = {
            buttonFocus: false,
            currentValue: '',
            predictive:
                this.props.predictiveValues ? this.props.predictiveValues : [],
            values: this.props.values ? this.props.values : [],
        };
        this.keyPress = this.keyPress.bind(this);
        this.onChangeText = this.onChangeText.bind(this);
        this.focus = this.focus.bind(this);
    }

    public focus() {
        this.state.textInput && this.state.textInput.focus(); //tslint:disable-line
    }

    public render() {
        const { window: { width, multiplier = 1, landscape }, showError, label, scroll: { scroller }, moreSpace = false } = this.props;//tslint:disable-line
        const { predictive, values, mouseOver } = this.state;

        const web = RX.Platform.getType() === 'web';
        const outsideWidth = (landscape ? 112 : 64) * multiplier;

        // tslint:disable:max-line-length
        return (
            <RX.View>
                <RX.Text id='inputLabel' style={[subHeader(multiplier), styles.label, { marginTop: 12 * multiplier, marginBottom: 12 * multiplier }]}>{label}{values.length === 0 && <RX.Text style={{ color: colors.alert }}> *</RX.Text>}</RX.Text>
                {showError && <RX.Text style={{ color: colors.alert, fontWeight: 'bold', fontSize: 16 * multiplier }}>This field is required.</RX.Text>}
                <RX.View style={{ flexDirection: 'row' }}>
                    <RX.TextInput
                        ref={(textInput) => {
                            if (this.state.textInput) {
                                return this.state.textInput
                            } else {
                                this.setState({ textInput });
                                this.props.dispatch({ type: 'TEXT_INPUT', focusTextInput: this.focus })
                            }
                        }}
                        editable={values.length < 60}
                        value={this.state.currentValue}
                        placeholder={t('multiInput.text')}
                        onChangeText={this.onChangeText}
                        style={[
                            styles.textInput,
                            {
                                borderColor: colors.lightGrey,
                                borderRadius: 4,
                                borderWidth: 1 * multiplier,
                                fontSize: 16 * multiplier,
                                marginRight: 8 * multiplier,
                                padding: 18 * multiplier,
                                width: web || landscape ? (width - outsideWidth) * .75 - 29 * multiplier : width - 64 - 125 - 9
                            },
                            ...applyBreakpoints(width, { md: styles.mediumWidth })
                        ]}
                        onSubmitEditing={this.keyPress}
                        onFocus={(e: any) => {
                            const inputLabel = web && document.getElementById('inputLabel');
                            const userAgent = web && window.navigator.userAgent;
                            const mobile = userAgent && (userAgent.indexOf('iPhone') > -1 || userAgent.indexOf('iPad') > -1 || userAgent.indexOf('Android') > -1);
                            web && mobile && inputLabel && inputLabel.scrollIntoView(); //tslint:disable-line
                            !web && scroller && scroller({ x: 0, y: moreSpace ? 500 : 425 })//tslint:disable-line
                        }}
                        onBlur={(e: any) => {
                            if (RX.Platform.getType() === 'web') {
                                const inputLabel = web && document.getElementById('inputLabel');
                                const target = e.relatedTarget || document.activeElement;
                                const submit = target && target.type === 'submit';
                                const userAgent = web && window.navigator.userAgent;
                                const mobile = userAgent && (userAgent.indexOf('iPhone') > -1 || userAgent.indexOf('iPad') > -1 || userAgent.indexOf('Android') > -1);
                                !submit && web && mobile && inputLabel && inputLabel.scrollIntoView(); //tslint:disable-line
                                !submit && !web && scroller && scroller({ x: 0, y: moreSpace ? 500 : 425 })//tslint:disable-line
                                const clickedText = target && target.id;
                                submit ? target.click() :
                                    clickedText ?
                                        predictive.reduce((acc, item) => { return acc ? acc : item.value === clickedText }, false) && this.predictivePress(clickedText) //tslint:disable-line
                                        : this.setState({ mouseOver: '', predictive: [] });
                            }
                        }}
                        onKeyPress={(event) => {
                            if (event.key === 'ArrowDown') {
                                let newIndex = findIndex(mouseOver, predictive) + 1;
                                if (newIndex === predictive.length) {
                                    newIndex = 0;
                                }
                                this.mouseOver(predictive[newIndex].value);
                            }

                            if (event.key === 'ArrowUp') {
                                let newIndex = findIndex(mouseOver, predictive);
                                if (newIndex === 0) {
                                    newIndex = predictive.length - 1;
                                } else {
                                    newIndex--;
                                }

                                this.mouseOver(predictive[newIndex].value);
                            }
                        }} //tslint:disable-line
                    />
                    <RX.Button
                        id='add-symptom'
                        disabled={values.length >= 60}
                        onFocus={() => { this.state.mouseOver ? this.keyPress() : this.setState({ buttonFocus: true }); }} //tslint:disable-line
                        onBlur={() => { this.setState({ buttonFocus: false }) }}
                        onPress={this.keyPress}
                        style={[
                            styles.submitButton,
                            {
                                alignItems: 'center',
                                backgroundColor: this.state.buttonFocus ? colors.primary : colors.secondary,
                                borderRadius: 5 * multiplier,
                                maxWidth: 150 * multiplier,
                                padding: 12,
                                width: web || landscape ? (width - outsideWidth) * .25 : 125,
                            }]}
                    >
                        <RX.Text style={{ color: colors.white, fontSize: (multiplier) > 1 ?  12 * (multiplier) :  16 * (multiplier), fontWeight: 'bold' }}>Add Symptom</RX.Text>
                    </RX.Button>
                    {(values.length !== 0 ) && RX.createElement(Check, { style: { color: colors.green, height: 35 * multiplier, width: 35 * multiplier, } })}
                    {(showError) && RX.createElement(ErrorX, { style: { color: colors.red, height: 35 * multiplier, width: 35 * multiplier, } })}

                </RX.View>
                {values.length >= 60 && <RX.View>
                    <RX.Text style={{ marginTop: 4, color: colors.alert }}>You have entered the maxiumum number of symptoms</RX.Text>
                </RX.View>}
                {predictive.length > 0 &&
                    <RX.View style={[
                        styles.predictive,
                        {
                            borderWidth: 1 * multiplier,
                            marginTop: -1 * multiplier,
                            width: web ? (width - outsideWidth) * .75 - 9 * multiplier : width - 64 - 125 - 9,
                        },
                        ...applyBreakpoints(width, { md: styles.mediumWidth, })
                    ]}
                    >
                        {predictive.map((option: any) =>
                            <RX.View
                                tabIndex={0}
                                id={option.value}
                                onMouseEnter={() => {
                                    this.mouseOver(option.value) //tslint:disable-line
                                }} //tslint:disable-line
                                onMouseLeave={(e) => {
                                    this.setState({ mouseOver: option.value });
                                }}
                                key={option.value}
                                style={[
                                    styles.predictiveOption,
                                    {
                                        backgroundColor: this.state.mouseOver === option.value ? colors.primary : colors.white,
                                        padding: 12 * multiplier
                                    }
                                ]}
                                onPress={() => {
                                    const inputLabel = web && document.getElementById('inputLabel');
                                    this.predictivePress(option.value);
                                    const userAgent = web && window.navigator.userAgent;
                                    const mobile = userAgent && (userAgent.indexOf('iPhone') > -1 || userAgent.indexOf('iPad') > -1 || userAgent.indexOf('Android') > -1);
                                    web && mobile && inputLabel && inputLabel.scrollIntoView(); //tslint:disable-line
                                    !web && scroller && scroller({ x: 0, y: moreSpace ? 500 : 425 })//tslint:disable-line
                                }}
                            >
                                <RX.Text
                                    id={option.value}
                                    onPress={() => {
                                        const inputLabel = web && document.getElementById('inputLabel');
                                        this.predictivePress(option.value);
                                        const userAgent = web && window.navigator.userAgent;
                                        const mobile = userAgent && (userAgent.indexOf('iPhone') > -1 || userAgent.indexOf('iPad') > -1 || userAgent.indexOf('Android') > -1);
                                        web && mobile && inputLabel && inputLabel.scrollIntoView(); //tslint:disable-line
                                        !web && scroller && scroller({ x: 0, y: moreSpace ? 500 : 425 })//tslint:disable-line
                                    }}
                                    style={[
                                        {
                                            color: this.state.mouseOver === option.value ? colors.white : colors.black,
                                            fontSize: 14 * multiplier,
                                        }
                                    ]}>{option.value}</RX.Text>
                            </RX.View>)}
                    </RX.View>}
                <RX.View style={[styles.optionWrapper, { marginTop: 8 * multiplier }]}>
                    {values && values.map((value) =>
                        <RX.View key={value}
                            style={[
                                styles.option,
                                {
                                    marginBottom: 8 * multiplier,
                                    marginRight: 8 * multiplier,
                                    padding: 12 * multiplier,
                                }
                            ]}
                            onPress={() => this.onPress(value)}>
                            <RX.Text style={[{ color: colors.white }, body(multiplier)]}>{value}</RX.Text>
                            <RX.Text style={[styles.x, body(multiplier), { marginLeft: 8 * multiplier }]}>X</RX.Text>
                        </RX.View>)
                    }
                </RX.View>
            </RX.View>
        );
    }

    private keyPress() {
        const { values, currentValue, mouseOver } = this.state;
        const submitValue = mouseOver ? mouseOver : currentValue;
        const newValue = submitValue.replace(/,\sand/g, ',');
        const valueArray = newValue.split(',');
        valueArray.map((val) => {
            const trimmedVal = val.trim()
            const idx = values.indexOf(trimmedVal.toLowerCase());
            idx === -1 && trimmedVal !== '' && trimmedVal.toLowerCase() !== 'and' && values.push(trimmedVal); //tslint:disable-line
        });
        this.setState({ values, currentValue: '', predictive: [], mouseOver: '', buttonFocus: false });
        this.props.onChange({ value: values });
    }

    private onChangeText(newValue: string) {
        const removeLeadingSpace = newValue.replace(/^\s+/g, '')
        const onlyAlpha = removeLeadingSpace.replace(/[^a-zA-Z,\s]/g, '');
        this.setState({ currentValue: onlyAlpha });

        const strippedValue = onlyAlpha.trim().toLowerCase();

        strippedValue && axios({
            headers: {
                'Access-Control-Allow-Origin': 'https://wdigfc-app.eastus.cloudapp.azure.com',
            },
            method: 'GET',
            params: {
                symptom: strippedValue
            },
            url: predictiveText
        }).then((response: any) => { this.setState({ predictive: response.data, mouseOver: response.data && response.data[0] ? response.data[0].value : '' }) }).catch((error) => {
            if (error.message && error.message === 'Network Error') {
                this.props.dispatch({ type: 'SHOW_POPUP', children: <RX.Text style={{ fontSize: 14 * this.props.window.multiplier }}>The application is currently offline. Please check your internet connection and try again.</RX.Text> }); //tslint:disable-line
            }
        }); //tslint:disable-line
    }

    private predictivePress(value: string) {
        const { values } = this.state;
        const trimmedVal = value.trim()
        const pos = values.indexOf(trimmedVal);
        if (pos === -1) {
            values.push(trimmedVal);
        }
        this.setState({ values, predictive: [], currentValue: '', mouseOver: '' });
        this.props.onChange({ value: values });
    }

    private onPress(value: string) {
        const { values } = this.state;
        const pos = values.indexOf(value);
        values.splice(pos, 1);
        this.setState({ values, predictive: [], currentValue: '' });
        this.props.onChange({ value: values });
    }

    private mouseOver(mouseState: string) {
        this.setState({ mouseOver: mouseState });
    }
}

export default connect(mapStateToProps)(MultiTextInput);



// WEBPACK FOOTER //
// ./src/components/multi_text_input/index.tsx